'use client';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@ahafood/ui/components/alert-dialog';
import { JSFunction } from '@ahm/common-helpers';
import { useCallback } from 'react';
import { clearSessionType } from '@/lib/auth/session-type';
import { clearWebinappToken } from '@/lib/auth/webinapp-token';
import { useNewAuthStore } from '@/store/use-new-auth-store';

/**
 * Dialog "phiên hết hạn" cho WEBINAPP (chỉ hiện khi token webinapp hỏng thật —
 * interceptor đã resync + retry vẫn 401 → set cờ `webinappExpired`).
 *
 * Webinapp KHÔNG có accounts SSO để tự re-login. Cách làm mới token = đóng
 * webview → user mở lại cửa hàng trong app Ahamove → app truyền `?token=` mới.
 * Nếu phiên trong app cũng hết → app tự yêu cầu đăng nhập lại (an toàn).
 *
 * Dialog KHÔNG cho dismiss (terminal): chỉ 1 nút confirm → `JSFunction close`.
 * Mount 1 lần ở tầng NewAuthProvider.
 */
export function WebinappExpiredDialog() {
  const webinappExpired = useNewAuthStore.use.webinappExpired();

  const handleReopen = useCallback(() => {
    // Dọn token/marker hỏng để lần load sau (nếu webview không đóng) không flash
    // trạng thái "đang đăng nhập" rồi lại 401.
    clearWebinappToken();
    clearSessionType();
    try {
      JSFunction.call({ name: 'close' });
    } catch {
      /* bridge vắng (dev/browser) → dialog giữ nguyên, user tự đóng webview */
    }
  }, []);

  return (
    <AlertDialog open={webinappExpired}>
      <AlertDialogContent className="max-w-[300px] rounded-2xl">
        <AlertDialogHeader className="items-center text-center">
          <AlertDialogTitle>Phiên đăng nhập đã hết hạn</AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            Vui lòng mở lại từ ứng dụng Ahamove để tiếp tục đặt món.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction className="w-full" onClick={handleReopen}>
            Đóng
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
